
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feed/[id]",
      function () {
        return require("private-next-pages/feed/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feed/[id]"])
      });
    }
  